// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchItem_wrapper__FeJv4","leftDiv":"SearchItem_leftDiv__frjg7","contentDiv":"SearchItem_contentDiv__bd0oA","rightDiv":"SearchItem_rightDiv__IvBk1"};